import type { ChatContextType } from "@/features/chat/types";

export const CLASSIFIED_AD_CONTEXT_TYPE = "Core::ClassifiedAd" satisfies ChatContextType;
export const CLASSIFIED_AD_CONTEXT_TYPE_LEGACY = "classified_ad" satisfies ChatContextType;

export const isClassifiedAdContextType = (type?: string | null): boolean =>
  type === CLASSIFIED_AD_CONTEXT_TYPE || type === CLASSIFIED_AD_CONTEXT_TYPE_LEGACY;
